/**
 * adminReducer.js
 * Stores the current logged-in admin's record from the adminUsers collection.
 */

const initialState = {
  adminRecord: null, // full Firestore document
};

export const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ADMIN_RECORD":
      return { ...state, adminRecord: action.payload };
    case "CLEAR_ADMIN_RECORD":
      return { ...state, adminRecord: null };
    default:
      return state;
  }
};
